import NProgress from 'nprogress' // progress bar
import '@/components/NProgress/nprogress.less' // progress bar custom style
import { ACCESS_TOKEN, PERMISSION } from '@/store/mutation-types'
import { hasPermission } from './permission'
import ls from '@/utils/Storage'
import { setDocumentTitle } from '@/utils/domUtil'
import type { Router } from 'vue-router';
import { notification } from 'ant-design-vue';

NProgress.configure({ showSpinner: true }) // NProgress Configuration

const whiteList:Array = ['index','login', 'register', 'registerResult','page'] // 不进行拦截的路由名称集合

export const setupBeforeEach = (router: Router) => {
  router.beforeEach((to, from, next) => {
    NProgress.start() // 加载进度条
    setDocumentTitle(to)
       if(ls.get(ACCESS_TOKEN)==null) {
        if (whiteList.includes(to.name)) {
          next()
        } else {
          next({ path: '/login', query: { redirect: to.fullPath } })
        }
      }else{
        next()
      }
      NProgress.done()
  })

  // 路由懒加载失败时的提示
  router.onError((error) => {
    if (window.env === 'localhost') {
      notification.error({
        message: 'Dynamic import error',
        description: error.stack,
      });
    } else {
      router.push({ name: 'error', params: { errorMsg: error.stack } })
    }
  })
}

export const setupAfterEach = (router: Router) => {
  router.afterEach(() => {
    NProgress.done() // finish progress bar
  })
}
